import { closestCorners, type ClientRect, type KeyboardCoordinateGetter } from "@dnd-kit/core";

const AHEAD: Record<string, (from: ClientRect, to: ClientRect) => boolean> = {
  ArrowDown: (from, to) => from.top < to.top,
  ArrowUp: (from, to) => from.top > to.top,
  ArrowRight: (from, to) => from.left < to.left,
  ArrowLeft: (from, to) => from.left > to.left,
};

export const cardKeyboardCoordinates: KeyboardCoordinateGetter = (event, { context }) => {
  const ahead = AHEAD[event.code];
  if (!ahead) return undefined;

  event.preventDefault();
  const { active, collisionRect, droppableRects, droppableContainers, over } = context;
  if (!active || !collisionRect) return undefined;

  const candidates = droppableContainers.getEnabled().filter(container => {
    const rect = droppableRects.get(container.id);
    return rect !== undefined && ahead(collisionRect, rect);
  });
  const [closest, next] = closestCorners({ active, collisionRect, droppableRects, droppableContainers: candidates, pointerCoordinates: null });
  const target = closest?.id === over?.id && next ? next : closest;
  const rect = target && droppableRects.get(target.id);

  return rect ? { x: rect.left, y: rect.top } : undefined;
};
